import React, { useEffect } from "react";
import axios from "axios";
import { API_BASE_URL, API_URLS, LOCALSTORAGE_TOKEN_ITEM } from "constants/api";
import { Track } from "types/track";
import { Artist } from "types/artist";
import { Country } from "types/country";
import { Platform } from "types/platform";
import { Release } from "types/release";

export interface Label {
  id: string;
  name: string;
}

interface Response {
  artists: Artist[];
  countries: Country[];
  platforms: Platform[];
  labels: Label[];
  releases: Release[];
  tracks: Track[];
}

export const useAnalyticsFilters = () => {
  const [filters, setFilters] = React.useState<Response>();
  const [fetching, setFetching] = React.useState(true);
  const token = localStorage.getItem(LOCALSTORAGE_TOKEN_ITEM);

  useEffect(() => {
    (async () => {
      try {
        setFetching(true);
        const response = await axios.get(
          `${API_BASE_URL}${API_URLS.AnalyticsFilters}`,
          { headers: { Accept: 'application/json', Authorization: `Bearer ${token}` } }
        );
        setFilters(response.data.data);
      } catch (e) {
        console.error(e);
      } finally {
        setFetching(false);
      }
    })();
  }, []);
  return { filters, fetching };
};
